import React, { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { DownloadArea } from '../components/DownloadArea'
import { Mainlink } from '../components/Mainlink'
import { Introduction } from '../components/Introduction'
import { Select } from '../components/Select'
import { useDispatch, useSelector } from 'react-redux'
import { addSelection } from '../store/selection/actions'
import { AppState } from '../store'
import { GlobalMaterialFolderItem, GlobalMaterialCategory, GlobalMaterial } from '../store/category/reducers'

type UrlParams = {
  category: string
  item: string
}

const getGridClasses = (amount: number, index: number) => {
  switch (amount) {
    case 1:
      return 'grid-span4 grid-shift4 grid-desktop-span6 grid-desktop-shift3 grid-tablet-span8 grid-tablet-shift2 grid-mobile-span12 grid-mobile-shift0'
    case 2:
      return index === 0
        ? 'grid-span4 grid-shift2 grid-tablet-span12 grid-tablet-shift0 grid-text-center grid-tablet-gap3-below'
        : 'grid-span4 grid-tablet-span12 grid-text-center grid-tablet-gap3-below'
    default:
      return 'grid-span4 grid-tablet-span12 grid-text-center grid-tablet-gap3-below'
  }
}

export const Item: React.FC<RouteComponentProps<UrlParams>> = (props) => {
  // this is a bit ugly, and smells a bit, but I think it's the best way of integrating with the current codebase

  useEffect(() => {
    window.initializeChosen()

    window.$('.equalheight-group2').matchHeight({
      property: 'min-height'
    })
  }, [])

  const { category, item: tag } = props.match.params
  const categories = useSelector((p: AppState) => p.categoriesReducer.categories)

  const item = Object.values(categories).reduce<GlobalMaterialFolderItem | undefined>((acc, c) => {
    const match = c.find((i) => i.itemId === tag)
    return match !== undefined && acc === undefined ? match : acc
  }, undefined)

  return (
    <>
      <div className="grid-outer-container">
        <div className="grid-row grid-gap2-below">
          <div className="grid-span12 grid-text-center">
            <Mainlink to={`/${category}`}>{window.translations['Material - Back to category']}</Mainlink>
          </div>
        </div>
      </div>

      {item === undefined ? (
        <div className="grid-outer-container grid-gap6-above">
          <div className="grid-row">
            <h3 className="grid-text-center">Not found</h3>
          </div>
        </div>
      ) : (
        <>
          <Introduction title={item!.materialTitle} text={item!.materialDetailsDescription} />

          <div className="grid-outer-container grid-gap6-below grid-laptop-gap0-below">
            <div className="grid-row">
              {item!.materialCategories.map((materialCategory, i) => (
                <div key={materialCategory.title} className={getGridClasses(item!.materialCategories.length, i)}>
                  <DownloadSection folderItem={item!} materialCategory={materialCategory} />
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  )
}

type DownloadSectionProps = {
  folderItem: GlobalMaterialFolderItem
  materialCategory: GlobalMaterialCategory
}

const DownloadSection: React.FC<DownloadSectionProps> = ({ folderItem, materialCategory }) => {
  const dispatch = useDispatch()
  const [selected, setSelected] = useState<GlobalMaterial | undefined>(undefined)

  return (
    <DownloadArea
      title={materialCategory.title}
      description={materialCategory.description}
      backgroundImage={
        materialCategory.icon === null
          ? 'https://www.universal-robots.com/img/linkitem/idea.png'
          : `${materialCategory.icon}`
      }
    >
      <Select
        placeholder={materialCategory.placeholder}
        onChange={(newValue) => setSelected(materialCategory.materials.find((m) => m.file === newValue))}
      >
        <option value="" />
        {materialCategory.materials.map((material) => (
          <option key={material.id!} value={material.file}>
            {material.title}
          </option>
        ))}
      </Select>

      {selected !== undefined && (
        <span
          className="button"
          onClick={() => {
            return dispatch(
              addSelection(
                [folderItem.category, folderItem.title, materialCategory.title, selected.title].join(' / '),
                selected!.file,
                selected!.title
              )
            )
          }}
        >
          {window.translations['Material - Select x'].replace('$item$', materialCategory.title)}
        </span>
      )}
    </DownloadArea>
  )
}
